import { Image, ValImage } from '@valbuild/next';

type LayoutType =
  | { fill: true; height?: never; width?: never }
  | { fill?: false | undefined; height: number; width: number };

type ProjectImageType = {
  alt: string;
  cover?: boolean;
  priority?: boolean;
  src: Image;
} & LayoutType;

const ProjectImage = ({
  alt,
  cover,
  fill,
  height,
  src,
  priority,
  width,
}: ProjectImageType) => (
  <ValImage
    src={src}
    alt={alt}
    width={width}
    height={height}
    fill={fill}
    sizes={fill ? '1200px' : undefined}
    className={`${cover ? 'object-cover' : 'object-contain'}`}
    priority={priority}
    style={{ width, height }}
  />
);

export default ProjectImage;
